var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1212 4C12.1212 1.79086 13.8849 0 16.0606 0C18.2362 0 20 1.79086 20 4C20 6.20914 18.2362 8 16.0606 8C14.962 8 13.9692 7.54315 13.2554 6.80816L7.802 10.5954C7.85235 10.851 7.87882 11.115 7.87882 11.3846C7.87882 11.9186 7.77529 12.4291 7.58775 12.8957L13.5674 16.903C14.2461 16.3393 15.1145 16 16.0606 16C18.2362 16 20 17.7908 20 20C20 22.2091 18.2362 24 16.0606 24C13.8849 24 12.1212 22.2091 12.1212 20C12.1212 19.4214 12.2426 18.8706 12.4608 18.3733L6.52949 14.3984C5.8376 15.0118 4.93129 15.3846 3.93939 15.3846C1.76373 15.3846 0 13.5937 0 11.3846C0 9.17548 1.76373 7.38462 3.93939 7.38462C5.19047 7.38462 6.30415 7.9767 7.02524 8.89822L12.3105 5.2277C12.1875 4.84031 12.1212 4.42752 12.1212 4Z",
    fill: "#373A42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.d3a17fbe9842d29b25b3ebc436356f4c.svg";
export { ForwardRef as ReactComponent };